import "./App.css";
import "./themes/default.css";
import "./themes/plpsoft.css";
import "./themes/kwiper.css";
import Footer from "./components/ui/layout/footer/footer";
import Header from "./components/ui/layout/header/header";
import { AppUIContext, AppUIContextProvider } from "./providers/app-ui-context";
import MainContent from "./components/ui/layout/main-content/main-content";
import Content from "./components/ui/layout/content/content";
import AuthProvider, { AuthContext } from "./components/auth/auth-provider";
import Button from "./components/ui/controls/button/button";
import { FaAtom, FaCog, FaFileInvoice, FaGlobe, FaVideo } from "react-icons/fa";
import Settings from "./components/app/settings/settings";
import { createRef, useContext, useEffect, useState } from "react";
import RemExpertProvider, { AppContext } from "components/app/RemExprertProvider";
import AuditsPage from "pages/extranet/audits pager";
import AuditCompletPage from "pages/audit complet";
import AuditRetraitePage from "pages/audit retraite";
import AuditRemuPage from "pages/audit rémunération";
import AuditPrevPage from "pages/audit prévoyance";
import ClientsPage from "pages/extranet/clients pager";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import AdminPage from "pages/extranet/admin";
import InvoicesPage from "pages/extranet/invoices";
import AppContent from "AppContent";
import CalculatriceAgircArrcoPage from "pages/simulateurs/calculatrice AGIRC ARRCO";
import DeclarationPERPage from "pages/simulateurs/Déclaration PER";
import CorrectionPlafondPERPage from "pages/simulateurs/Correction plafond PER";
import StrategiePERPage from "pages/simulateurs/Strategie PER";
import AideVideoPager from "pages/extranet/aide video pager .js";
import Dialogs from "components/ui/dialogs/dialogs";
import CorrectionCarrierePage from "pages/simulateurs/Correction Carriere";

/**
 * Application component.
 * @returns Application component.
 */
const App = () => {
  // Initialiser les états
  const [preferencesVisibles, definirPreferencesVisibles] = useState(false);
  const [accessAdmin, setAccessAdmin] = useState(false);
  const [accessInvoices, setAccessInvoices] = useState(false);
  const context = useContext(AppContext);
  const [accesEtude, setAccessEtude] = useState("");

  // Gestionnaire des messages postMessage pour les boutons StudyManagement et CabinetManagement
  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     if (event.data && event.data.Action) {
  //       console.log('Message received:', event.data.Action);
  //       switch (event.data.Action) {
  //         case 'showPreferences':
  //           handleShowPreferences();
  //           break;
  //         case 'showInvoices':
  //           handleAccessInvoices();
  //           break;
  //         case 'showAdmin':
  //           handleAccessAdmin();
  //           break;
  //         case 'showHelp':
  //           handleAccessHelp();
  //           break;
  //         case 'goToAudits':
  //           context.handleValueChange("TypeSimulation", "");
  //           setAccessEtude(""); // Réinitialiser AccesEtude pour afficher la page principale des audits
  //           setAccessAdmin(false);
  //           setAccessInvoices(false);
  //           break;
  //         case 'goToExtranet':
  //           console.log(context.state.AccesSimulateur);
  //           context.handleValueChange("AccesSimulateur", false);
  //           console.log(context.state.AccesSimulateur);
  //           // context.handleValueChange("TypeSimulation", "");
  //           // setAccessEtude(""); // Réinitialiser AccesEtude pour un état propre
  //           // setAccessAdmin(false);
  //           // setAccessInvoices(false);
  //           break;
  //         case 'save':
  //           const saveIcon = document.querySelector('#saveModal');
  //           if (saveIcon && saveIcon.parentElement) {
  //             saveIcon.parentElement.click();
  //           } else {
  //             console.error("Save button not found for postMessage handler");
  //           }
  //           break;
  //         default:
  //           break;
  //       }
  //     }
  //   };

  //   window.addEventListener('message', handleMessage);

  //   return () => {
  //     window.removeEventListener('message', handleMessage);
  //   };
  // }, [context]);

  // Réinitialiser AccesEtude lors du changement d'utilisateur ou de la connexion
  useEffect(() => {
    // Réinitialiser l'état AccesEtude quand un utilisateur se connecte/change
    setAccessEtude("");
  }, [context.state.IdUser]); // Se déclenche quand l'ID utilisateur change

  const handleAccessDossier = () => {
    setAccessAdmin(false);
  };

  const handleAccessInvoices = () => {
    setAccessInvoices(true);
    setAccessAdmin(false);
  };

  const handleAccessHelp = () => {
    // L'aide vidéo ouvre maintenant directement YouTube, pas besoin de state
    console.log('Ouverture de l\'aide vidéo MAKO...');
    window.open('https://www.youtube.com/@MAKOLogiciels', '_blank');
  };

  const handleAccessAdmin = () => {
    setAccessAdmin(true);
    setAccessInvoices(false);
  };

  const handleShowPreferences = () => {
    definirPreferencesVisibles(true);
  };

  return (
    <RemExpertProvider>
      <AppContext.Consumer>
        {(context) => (
          <AppUIContextProvider name="MAKO" slogan="Logiciels" version="3.0.1">
            <AppUIContext.Consumer>
              {(ui) => (
                <div className={"App " + ui.theme}>
                  <AuthProvider authApiUrl="login">
                    <AuthContext.Consumer>
                      {(auth) => (
                        <AppContent>
                          <div style={{ zIndex: "999999" }} className={"modal-bg" + (context.state.v2 === undefined ? " hidden" : context.state.v2 === false ? " hidden" : "")}>
                            <div style={{ height: "250px", width: "450px" }} className="modal">
                              <Row className="modal-header">
                                <Column className="modal-icon">
                                  <FaGlobe />
                                </Column>
                              </Row>
                              <Row className="modal-content" fill>
                                <Column fill>
                                  <Row fill center>
                                    <Column fill center>
                                      Mise à niveau du dossier.
                                    </Column>
                                  </Row>
                                </Column>
                              </Row>
                            </div>
                          </div>
                          {/* <Modal
                            className="toto"
                            style={{ zIndex: "999999999" }}
                            width="450px"
                            height="25%"
                            title=" "
                            icon={<FaGlobe />}
                            visible={context.state.v2 === undefined ? false : context.state.v2}
                            onClose={() => {}}
                          >
                            <Column fill>
                              <Row fill center>
                                <Column fill center>
                                  Mis à niveau du dossier.
                                </Column>
                              </Row>
                            </Column>
                          </Modal> */}
                          <MainContent>
                            <Header
                              authInfos={auth}
                              userId={auth.utilisateur_identifie?.id}
                              gender={auth.utilisateur_identifie?.civilite === "MME" ? 1 : 0}
                              firstName={auth.utilisateur_identifie?.prenom}
                              lastName={auth.utilisateur_identifie?.nom}
                              subUserId={auth.utilisateur_reel?.id}
                              subGender={auth.utilisateur_reel?.civilite === "MME" ? 1 : 0}
                              subFirstName={auth.utilisateur_reel?.prenom}
                              subLastName={auth.utilisateur_reel?.nom}
                              company={auth.cabinet?.nom}
                              association={auth.groupement?.nom}
                              onDisconnect={() => {
                                auth.deconnecter();
                                context.handleValueChange("AccesSimulateur", false);
                                context.handleValueChange("TypeSimulation", "");
                                setAccessEtude(""); // Réinitialiser AccesEtude lors de la déconnexion
                              }}
                              disconnectDisabled={false}
                            />
                            {accessInvoices === true ? (
                              <Content>
                                <InvoicesPage IdCabinet={context.state.IdCabinet} />
                              </Content>
                            ) : accessAdmin === true ? (
                              <Content>
                                <AdminPage AccessDossier={handleAccessDossier} />
                              </Content>
                            ) : (
                              <Content>                                {console.log(context.state.AccesSimulateur)}
                                {/* <ChangerMDP /> */}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "" && <AuditsPage AccesEtude={accesEtude} SetAccessEtude={setAccessEtude} handleShowPreferences={handleShowPreferences} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Audit complet" && <AuditCompletPage accesEtude={accesEtude} SetAccessEtude={setAccessEtude}/>}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Audit retraite" && <AuditRetraitePage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Audit rémunération" && <AuditRemuPage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Audit prévoyance" && <AuditPrevPage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Calculatrice AGIRC ARRCO" && <CalculatriceAgircArrcoPage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Déclaration PER" && <DeclarationPERPage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Correction plafond PER" && <CorrectionPlafondPERPage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Stratégie PER" && <StrategiePERPage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === true && context.state.TypeSimulation === "Correction de carrière" && <CorrectionCarrierePage accesEtude={accesEtude} SetAccessEtude={setAccessEtude} />}
                                {context.state.AccesSimulateur === false && <ClientsPage handleShowPreferences={handleShowPreferences} />}
                              </Content>
                            )}
                            <Settings
                              visible={preferencesVisibles}
                              onClose={() => {
                                definirPreferencesVisibles(false);
                              }}
                            />
                            <Footer />
                          </MainContent>
                        </AppContent>
                      )}
                    </AuthContext.Consumer>
                  </AuthProvider>
                </div>
              )}
            </AppUIContext.Consumer>
          </AppUIContextProvider>
        )}
      </AppContext.Consumer>
    </RemExpertProvider>
  );
};

export default App;
